.container {
  position: absolute;
  width: fit-content;
  z-index: var(--dds-zindex-popover);
  padding: var(--dds-spacing-x0-75) var(--dds-spacing-x1)
    var(--dds-spacing-x1-5) var(--dds-spacing-x1);
}

.content--closable--no-header {
  margin-top: var(--dds-spacing-x2);
}

.header {
  margin-right: var(--dds-spacing-x2);
}

.close-button {
  position: absolute;
  top: var(--dds-spacing-x0-25);
  right: var(--dds-spacing-x0-25);
}
